<template>
    <div class="mt-4">
        <base-spinner v-if="isLoading"/>
        <base-page v-else-if="patient !== null">
            <patient-data class="mb-3 mx-3" @save="reloadPatient">
                <template v-slot:after-data>
                    <hemocir-button
                        :title="$t('utils.edit')"
                        font-awesome-icon="fa-pen"
                        class="ml-3"
                        variant="outline-gray"
                        @click="edit"
                    />
                </template>
            </patient-data>

            <b-nav class="mx-3" tabs>
                <b-nav-item
                    :to="{name: 'patient-detail-surgeries', params: {patientId: patientId}}"
                    :active-class="activeClass"
                >
                    {{ $tc('surgery.label', 2) }}
                </b-nav-item>
                <b-nav-item
                    :to="{name: 'patient-detail-previous-surgeries', params: {patientId: patientId}}"
                    class="ml-1"
                    :active-class="activeClass"
                >
                    {{ $tc('previousSurgery.label', 2) }}
                </b-nav-item>
                <b-nav-item v-if="isSurgeryDetail" class="ml-1" :active="true">
                    {{ $tc('surgery.detail.title') }}
                </b-nav-item>
            </b-nav>

            <div class="mx-3 bg-white">
                <router-view class="p-3"/>
            </div>
        </base-page>

        <p class="pt-3 px-3" v-else>
            {{ $t('error.notFound') }}
        </p>
    </div>
</template>

<script>
    import {mapActions, mapState} from "vuex";
    import PatientData from "@/components/patient/PatientData";
    import BasePageMixin from "@/components/BasePageMixin";
    import BasePage from "@/components/BasePage";
    import BaseSpinner from "@/components/BaseSpinner";

    export default {
        name: "PatientDetailPage",
        components: {
            BaseSpinner,
            BasePage,
            PatientData,
        },
        mixins: [BasePageMixin],
        props: {
            patientId: {
                type: Number,
                required: true,
            },
            isSurgeryDetail: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                addingSurgery: false,
                addingPreviousSurgery: false,
            };
        },
        computed: {
            ...mapState(['patient']),
            activeClass() {
                return 'active';
            }
        },
        async created() {
            try {
                await this.getPatientOptions();
                await this.getPatient(this.patientId);
            } catch (error) {
                if (error.response.status !== 404) {
                    throw error;
                }
            }
            this.isLoading = false;
        },
        methods: {
            ...mapActions([
                'getPatient',
                'getPatientOptions',
            ]),
            reloadPatient() {
                this.addingSurgery = false;
                this.addingPreviousSurgery = false;
            },
            edit() {
                this.$router.push({ name: 'patient-edit', params: { patientId: this.patient.id } });
            }
        },
    };
</script>

<style lang="scss" scoped>
    @import '../../custom';

    .nav-item .nav-link {
        color: $tab-non-active;
        background-color: $tab-non-active-bg;

        &.active {
            color: $tab-active;
            background-color: $tab-active-bg;
            font-weight: bold;
        }
    }
</style>